import React from 'react';
import { RendererProps } from '@tunz/data-tables';
import { LinkProps } from './types';
import RouterLinkFormatterV2 from './RouterLinkFormatterV2';

const WalletLinkFormatter = RouterLinkFormatterV2(
	(value) => `?wallet=${value}`,
	'PlatformAPIService',
	'GET:/wallets/{walletId}/',
	'wallets',
	true,
);

export const WalletLink: React.FC<LinkProps> = ({ id }) => (
	<WalletLinkFormatter value={id} record={{ value: id }} />
);

export const WalletLinkRenderer = ({ value, record }: RendererProps<string>): React.JSX.Element => (
	<span className="mx-2">
		<WalletLinkFormatter value={value} record={record} />
	</span>
);
